<template>
  <div class="pagination-container">
    <!-- Previous Button -->
    <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
      <span>❮ PREVIOUS</span>
    </button>

    <!-- Page Numbers and Ellipses -->
    <span
      v-for="(page, index) in pages"
      :key="index"
      @click="changePage(page)"
      :class="['page-number', { active: page === currentPage, disabled: page === '...' }]"
    >
      {{ page }}
    </span>

    <!-- Next Button -->
    <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
      <span>NEXT ❯</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const delta = 1; // Number of pages to show before and after the current page
      const range = [];
      const rangeWithDots = [];
      let l;

      // Always include the first page
      range.push(1);

      // Determine pages to display around the current page
      if (current - delta > 2) {
        range.push('...');
      }
      for (let i = Math.max(2, current - delta); i <= Math.min(total - 1, current + delta); i++) {
        range.push(i);
      }
      if (current + delta < total - 1) {
        range.push('...');
      }

      // Always include the last page
      if (total > 1) {
        range.push(total);
      }

      // Merge range into rangeWithDots, handling ellipses
      for (let i of range) {
        if (l) {
          if (i === '...' && l !== '...') {
            rangeWithDots.push('...');
          } else if (i !== '...') {
            rangeWithDots.push(i);
          }
        } else {
          rangeWithDots.push(i);
        }
        l = i;
      }

      return rangeWithDots;
    },
  },
  methods: {
    changePage(page) {
      if (page !== "..." && page >= 1 && page <= this.totalPages) {
        this.$emit("update:currentPage", page);
      }
    },
  },
};
</script>
<style scoped>
.page-number.disabled {
  pointer-events: none;
  cursor: default;
}
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 20px;
}

button {
  background: #309255;
  color: white;
  border: 1px solid #ccc;
  padding: 8px 15px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.page-number {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
}

.page-number.active {
  background: #309255;
  color: white;
  font-weight: bold;
}

.page-number:hover {
  background: #ddd;
}
</style>